/**
 * @generated SignedSource<<8273fe7b6ff96296ffab96bc69fec30a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NodeLeftFrame_Query$variables = {
  learnOpportunityId: string;
};
export type NodeLeftFrame_Query$data = {
  readonly Viewer: {
    readonly Auth: {
      readonly currentUser: {
        readonly user: {
          readonly " $fragmentSpreads": FragmentRefs<"DefaultContainer_UserDataFragment" | "UserStatusMessage_UserFragment">;
        };
      } | null;
    };
  };
  readonly node: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"NodeLeftFrame_NodeFragment">;
  } | null;
};
export type NodeLeftFrame_Query = {
  response: NodeLeftFrame_Query$data;
  variables: NodeLeftFrame_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "learnOpportunityId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "learnOpportunityId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v5 = [
  (v4/*: any*/),
  (v2/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lengthInSecondsOverride",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pacPoints",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pharmaPoints",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "WordpressCertificateAndLearnState",
  "kind": "LinkedField",
  "name": "wordpressCertificates",
  "plural": true,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstLearnOpportunityIdWithMultipleChoiceElement",
  "storageKey": null
},
v13 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "reasonConfigTypes",
    "storageKey": null
  }
],
v14 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "viewerTreeState",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "kind",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v13/*: any*/),
      "type": "CanNotBeStartedViewerTreeState",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "headContentId",
          "storageKey": null
        }
      ],
      "type": "IsStartedViewerTreeState",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortDescription",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "definitionType",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headFirstElementType",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "containedElementTypes",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "structureDefinition",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NodeLeftFrame_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "NodeLeftFrame_NodeFragment"
              }
            ],
            "type": "LearnOpportunityV2",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ViewerQueryType",
        "kind": "LinkedField",
        "name": "Viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AuthViewerSchema",
            "kind": "LinkedField",
            "name": "Auth",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CurrentUser",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "DefaultContainer_UserDataFragment"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "UserStatusMessage_UserFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NodeLeftFrame_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "File",
                "kind": "LinkedField",
                "name": "image",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LearnOpportunityV2",
                "kind": "LinkedField",
                "name": "root",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "structureDefinition",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Tag",
                            "kind": "LinkedField",
                            "name": "tags",
                            "plural": true,
                            "selections": [
                              (v2/*: any*/),
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "colorHex",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "File",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": (v5/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "extension",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "InfectopharmTreeConfigConsequences",
                                    "kind": "LinkedField",
                                    "name": "configConsequences",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "restartTriesCount",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "isRewardedTo",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "rewardExpired",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "showAnswerExpired",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "totalUserTries",
                                    "storageKey": null
                                  },
                                  (v8/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ReducedDataInTree",
                                    "kind": "LinkedField",
                                    "name": "reducedDataInTree",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      (v10/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v11/*: any*/),
                                  (v12/*: any*/)
                                ],
                                "type": "LearnOpportunityRootExtensionImpl",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v14/*: any*/)
                        ],
                        "type": "LearnOpportunityRootStructureDefinition",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "attachmentsV2",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v2/*: any*/),
                      (v6/*: any*/),
                      (v15/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "File",
                            "kind": "LinkedField",
                            "name": "file",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v2/*: any*/),
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "fileType",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "accessType",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "InfectopharmFileAttachment",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "typeDefinition",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LearnOpportunityV2",
                            "kind": "LinkedField",
                            "name": "children",
                            "plural": true,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "attachmentsV2",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "File",
                                        "kind": "LinkedField",
                                        "name": "file",
                                        "plural": false,
                                        "selections": (v5/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "InfectopharmFileAttachment",
                                    "abstractKey": null
                                  },
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "LearnOpportunityBranchTypeDefinition",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "structureDefinition",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v6/*: any*/),
                  (v17/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "extension",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v12/*: any*/)
                            ],
                            "type": "LearnOpportunityRootExtensionImpl",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "LearnOpportunityRootStructureDefinition",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "typeDefinition",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v17/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "extension",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v9/*: any*/),
                              (v8/*: any*/),
                              (v10/*: any*/),
                              (v18/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "amountOfMultipleChoiceElementsInContentSubmission",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContentConfigConsequences",
                                "kind": "LinkedField",
                                "name": "configConsequences",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "percentageRequiredToPass",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isBlockedPermanentlyAfterNumFailedTries",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isBlockedTemporarilyForNumDaysAfterOneFailedTry",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "LearnContentExtensionImpl",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "contentNodeAdvancementResult",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v19/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v20/*: any*/)
                    ],
                    "type": "LearnOpportunityELearningContentTypeDefinition",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LearnOpportunityV2",
                        "kind": "LinkedField",
                        "name": "children",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "typeDefinition",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v17/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "contentNodeAdvancementResult",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v19/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v13/*: any*/),
                                        "type": "CanNotBeStartedContentNodeAdvancementResult",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "activeContentSubmissionId",
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "ContinueContentNodeAdvancementResult",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "configResults",
                                            "plural": true,
                                            "selections": [
                                              (v3/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "configType",
                                                "storageKey": null
                                              },
                                              {
                                                "kind": "TypeDiscriminator",
                                                "abstractKey": "__isRestartIfFailedContentConfigResult"
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "canBeRestarted",
                                                "storageKey": null
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "blockedUntil",
                                                    "storageKey": null
                                                  }
                                                ],
                                                "type": "NegativeBlockTemporarilyRestartIfFailedContentConfigResult",
                                                "abstractKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "CanNotBeRestartedAfterFailedContentNodeAdvancementResult",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v20/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "extension",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v9/*: any*/),
                                          (v10/*: any*/),
                                          (v18/*: any*/)
                                        ],
                                        "type": "LearnContentExtensionImpl",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "LearnOpportunityELearningContentTypeDefinition",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v16/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LearnOpportunityV2",
                            "kind": "LinkedField",
                            "name": "root",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "structureDefinition",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v6/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "extension",
                                        "plural": false,
                                        "selections": [
                                          (v3/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v11/*: any*/)
                                            ],
                                            "type": "LearnOpportunityRootExtensionImpl",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v14/*: any*/)
                                    ],
                                    "type": "LearnOpportunityRootStructureDefinition",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v21/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "LearnOpportunityBranchTypeDefinition",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "previousContentNodeId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nextContentNodeId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LearnOpportunityV2",
                "kind": "LinkedField",
                "name": "path",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v21/*: any*/)
                ],
                "storageKey": null
              },
              (v15/*: any*/)
            ],
            "type": "LearnOpportunityV2",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ViewerQueryType",
        "kind": "LinkedField",
        "name": "Viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AuthViewerSchema",
            "kind": "LinkedField",
            "name": "Auth",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CurrentUser",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "userExtensionKind",
                            "value": "InfectopharmUserExtension"
                          }
                        ],
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "extension",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "salutation",
                                "storageKey": null
                              },
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lastName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "firstName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "efnNumber",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "globalUserStatus",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "country",
                                "storageKey": null
                              }
                            ],
                            "type": "InfectopharmUserExtension",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": "extension(userExtensionKind:\"InfectopharmUserExtension\")"
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f8fa876628cdc45e9bc0ea57f3160d88",
    "id": null,
    "metadata": {},
    "name": "NodeLeftFrame_Query",
    "operationKind": "query",
    "text": "query NodeLeftFrame_Query(\n  $learnOpportunityId: ID!\n) {\n  node(id: $learnOpportunityId) {\n    __typename\n    id\n    ... on LearnOpportunityV2 {\n      id\n      ...NodeLeftFrame_NodeFragment\n    }\n  }\n  Viewer {\n    Auth {\n      currentUser {\n        user {\n          ...DefaultContainer_UserDataFragment\n          ...UserStatusMessage_UserFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment AttachmentButtonsDisplayFragment_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  root {\n    id\n    attachmentsV2 {\n      __typename\n      title\n      description\n      ... on InfectopharmFileAttachment {\n        file {\n          id\n          url\n          name\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment AttachmentCard_AttachmentFragment on InfectopharmFileAttachment {\n  id\n  file {\n    name\n    url\n    fileType\n    accessType\n    id\n  }\n  title\n  description\n}\n\nfragment AttachmentDisplay_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  root {\n    id\n    attachmentsV2 {\n      __typename\n      ... on InfectopharmFileAttachment {\n        ...AttachmentCard_AttachmentFragment\n      }\n      id\n    }\n  }\n}\n\nfragment AttachmentHeftDisplay_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  id\n  structureDefinition {\n    __typename\n    ... on LearnOpportunityRootStructureDefinition {\n      extension {\n        __typename\n        ... on LearnOpportunityRootExtensionImpl {\n          firstLearnOpportunityIdWithMultipleChoiceElement\n        }\n      }\n    }\n  }\n  root {\n    id\n    structureDefinition {\n      __typename\n      ... on LearnOpportunityRootStructureDefinition {\n        extension {\n          __typename\n          ... on LearnOpportunityRootExtensionImpl {\n            firstLearnOpportunityIdWithMultipleChoiceElement\n          }\n        }\n      }\n    }\n    attachmentsV2 {\n      __typename\n      ... on InfectopharmFileAttachment {\n        file {\n          url\n          id\n        }\n      }\n      id\n    }\n    typeDefinition {\n      __typename\n      ... on LearnOpportunityBranchTypeDefinition {\n        children {\n          id\n          attachmentsV2 {\n            __typename\n            ... on InfectopharmFileAttachment {\n              file {\n                url\n                id\n              }\n            }\n            id\n          }\n        }\n      }\n    }\n  }\n  ...AttachmentButtonsDisplayFragment_LearnOpportunityV2Fragment\n}\n\nfragment DefaultContainer_UserDataFragment on User {\n  ...MainTopBar_UserDataFragment\n}\n\nfragment MainTopBar_UserDataFragment on User {\n  ...ProfileLink_UserDataFragment\n}\n\nfragment NavigateDirectToQuestionsAdvanceTreeButton_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  id\n  shortDescription\n  root {\n    id\n    structureDefinition {\n      __typename\n      title\n      ... on LearnOpportunityRootStructureDefinition {\n        extension {\n          __typename\n          ... on LearnOpportunityRootExtensionImpl {\n            wordpressCertificates {\n              id\n            }\n          }\n        }\n        viewerTreeState {\n          __typename\n          kind\n          ... on CanNotBeStartedViewerTreeState {\n            reasonConfigTypes\n          }\n          ... on IsStartedViewerTreeState {\n            headContentId\n          }\n        }\n      }\n    }\n  }\n  structureDefinition {\n    __typename\n    title\n  }\n  typeDefinition {\n    __typename\n    definitionType\n    ... on LearnOpportunityELearningContentTypeDefinition {\n      containedElementTypes\n      contentNodeAdvancementResult {\n        __typename\n        status\n      }\n      extension {\n        __typename\n        ... on LearnContentExtensionImpl {\n          pacPoints\n          pharmaPoints\n          headFirstElementType\n        }\n      }\n    }\n  }\n}\n\nfragment NodeBreadcrumbs_NodeFragment on LearnOpportunityV2 {\n  id\n  path {\n    id\n    structureDefinition {\n      __typename\n      title\n    }\n  }\n  structureDefinition {\n    __typename\n    title\n  }\n}\n\nfragment NodeConfigurationsDisplay_NodeFragment on LearnOpportunityV2 {\n  root {\n    structureDefinition {\n      __typename\n      ... on LearnOpportunityRootStructureDefinition {\n        extension {\n          __typename\n          ... on LearnOpportunityRootExtensionImpl {\n            configConsequences {\n              rewardExpired\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n  typeDefinition {\n    __typename\n    definitionType\n    ... on LearnOpportunityELearningContentTypeDefinition {\n      extension {\n        __typename\n        ... on LearnContentExtensionImpl {\n          amountOfMultipleChoiceElementsInContentSubmission\n          configConsequences {\n            percentageRequiredToPass\n            isBlockedPermanentlyAfterNumFailedTries\n            isBlockedTemporarilyForNumDaysAfterOneFailedTry\n          }\n        }\n      }\n      containedElementTypes\n    }\n  }\n}\n\nfragment NodeContentElementsList_NodeFragment on LearnOpportunityV2 {\n  id\n  shortDescription\n  structureDefinition {\n    __typename\n    title\n  }\n  ...ProjectContentButtonCME_LearnOpportunityFragment\n  typeDefinition {\n    __typename\n    definitionType\n    ... on LearnOpportunityELearningContentTypeDefinition {\n      containedElementTypes\n    }\n    ... on LearnOpportunityBranchTypeDefinition {\n      children {\n        ...ProjectContentButtonCME_LearnOpportunityFragment\n        id\n        shortDescription\n        structureDefinition {\n          __typename\n          title\n        }\n        typeDefinition {\n          __typename\n          definitionType\n          ... on LearnOpportunityELearningContentTypeDefinition {\n            containedElementTypes\n            contentNodeAdvancementResult {\n              __typename\n              status\n              ... on CanNotBeStartedContentNodeAdvancementResult {\n                reasonConfigTypes\n              }\n              ... on ContinueContentNodeAdvancementResult {\n                activeContentSubmissionId\n              }\n              ... on CanNotBeRestartedAfterFailedContentNodeAdvancementResult {\n                configResults {\n                  __typename\n                  configType\n                  __isRestartIfFailedContentConfigResult: __typename\n                  canBeRestarted\n                  ... on NegativeBlockPermanentlyRestartIfFailedContentConfigResult {\n                    canBeRestarted\n                  }\n                  ... on NegativeBlockTemporarilyRestartIfFailedContentConfigResult {\n                    blockedUntil\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment NodeDescription_NodeFragment on LearnOpportunityV2 {\n  description\n}\n\nfragment NodeLeftFrame_NodeFragment on LearnOpportunityV2 {\n  id\n  image {\n    url\n    id\n  }\n  root {\n    id\n    structureDefinition {\n      __typename\n      title\n      ... on LearnOpportunityRootStructureDefinition {\n        tags {\n          id\n          name\n        }\n        icon {\n          url\n          id\n        }\n        extension {\n          __typename\n          ... on LearnOpportunityRootExtensionImpl {\n            configConsequences {\n              restartTriesCount\n              isRewardedTo\n              rewardExpired\n              showAnswerExpired\n            }\n            totalUserTries\n            lengthInSecondsOverride\n            reducedDataInTree {\n              pacPoints\n              pharmaPoints\n            }\n          }\n        }\n        ...NodeTagList_LearnOpportunityRootStructureDefinitionFragment\n      }\n    }\n  }\n  shortDescription\n  structureDefinition {\n    __typename\n    title\n    definitionType\n  }\n  typeDefinition {\n    __typename\n    definitionType\n    ... on LearnOpportunityELearningContentTypeDefinition {\n      extension {\n        __typename\n        ... on LearnContentExtensionImpl {\n          pacPoints\n          lengthInSecondsOverride\n        }\n      }\n    }\n  }\n  ...ProjectContentButtonCME_LearnOpportunityFragment\n  ...AttachmentHeftDisplay_LearnOpportunityV2Fragment\n  ...NodeNavigationButtons_NodeFragment\n  ...NodeBreadcrumbs_NodeFragment\n  ...NodeConfigurationsDisplay_NodeFragment\n  ...NodeContentElementsList_NodeFragment\n  ...AttachmentDisplay_LearnOpportunityV2Fragment\n  ...NodeDescription_NodeFragment\n  ...PaediaAttachmentButtonsDisplayFragment_LearnOpportunityV2Fragment\n}\n\nfragment NodeNavigationButtons_NodeFragment on LearnOpportunityV2 {\n  previousContentNodeId\n  nextContentNodeId\n}\n\nfragment NodeTagList_LearnOpportunityRootStructureDefinitionFragment on LearnOpportunityRootStructureDefinition {\n  tags {\n    id\n    ...NodeTag_TagFragment\n  }\n}\n\nfragment NodeTag_TagFragment on Tag {\n  id\n  name\n  colorHex\n}\n\nfragment PaediaAttachmentButtonsDisplayFragment_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  root {\n    id\n    attachmentsV2 {\n      __typename\n      title\n      description\n      ... on InfectopharmFileAttachment {\n        file {\n          id\n          url\n          name\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment ProfileLink_UserDataFragment on User {\n  extension(userExtensionKind: InfectopharmUserExtension) {\n    __typename\n    ... on InfectopharmUserExtension {\n      salutation\n      title\n      lastName\n      firstName\n      efnNumber\n    }\n  }\n}\n\nfragment ProjectContentButtonCME_LearnOpportunityFragment on LearnOpportunityV2 {\n  id\n  typeDefinition {\n    __typename\n    definitionType\n    ... on LearnOpportunityELearningContentTypeDefinition {\n      contentNodeAdvancementResult {\n        __typename\n        status\n      }\n    }\n  }\n  ...NavigateDirectToQuestionsAdvanceTreeButton_LearnOpportunityV2Fragment\n}\n\nfragment UserStatusMessage_UserFragment on User {\n  extension(userExtensionKind: InfectopharmUserExtension) {\n    __typename\n    ... on InfectopharmUserExtension {\n      globalUserStatus\n      country\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8e93f90cac65fdd637e72a843560d116";

export default node;
